export default __webpack_public_path__ + "static/media/logo.1d473a9c.png";